import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';
import type { AuthGuardData } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const isAuthenticated = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  if (authData.authenticated) return true;
  const keycloak = inject(Keycloak);
  await keycloak.login({ redirectUri: window.location.origin + state.url });
  return false;
};

export const authGuard = createAuthGuard(isAuthenticated);
